import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { DataGrid } from "@material-ui/data-grid";
import { Button, Modal, Form, InputGroup, Row, Col } from "react-bootstrap";
import SearchIcon from "@material-ui/icons/Search";
import { Paper, Grid, FormControl, Select, InputLabel, MenuItem, makeStyles, TextField, IconButton } from "@material-ui/core";
import CloudDownloadIcon from "@material-ui/icons/CloudDownload";
import Autocomplete from "@material-ui/lab/Autocomplete";
import * as Admin from "../../../store/ducks/admin.duck";
import { ToastContainer, Flip } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const useStyles = makeStyles((theme) => ({
  noBorder: {
    border: "none",
  },
  formControl: {
    margin: 0, //theme.spacing(1),
    minWidth: 120,
  },
  formControlWide: {
    margin: 0, //theme.spacing(1),
    minWidth: "100%",
  },
  selectEmpty: {
    marginTop: theme.spacing(2),
  },
  label: {
    backgroundColor: "#fff",
    paddingLeft: 3,
    paddingRight: 3,
  },
}));

const useStylesDatePicker = makeStyles({
  root: {
    "& .MuiInputBase-root": {
      height: 33,
    },
  },
});

export default function GatherBillableAll() {
  const dispatch = useDispatch();
  const classes = useStyles();
  const classesDatePicker = useStylesDatePicker();

  const billableIntentsAll = useSelector((state) => state.admin.BillableIntentsAll);
  const registered = useSelector((state) => state.admin.RegisteredPsychologists);
  const contracts = useSelector((state) => state.admin.Contracts);
  const filters = useSelector((state) => state.admin.Filters);
  const bookingInvoice = useSelector((state) => state.admin.ProviderBookingInvoice);
  const [searchTerm, setSearchTerm] = useState("");

  const initContract = () => {
    return { id: 0, name: "" };
  };
  const [currentContract, setcurrentContract] = useState(initContract());
  const loadContract = (thisContract) => {
    setcurrentContract(thisContract ? thisContract : initContract());
  };

  useEffect(() => {
    dispatch(
      Admin.actions.fetchBillableIntentsAll({
        startDate: filters.invoiceStartDate,
        endDate: filters.invoiceEndDate,
      }),
    );
  }, [dispatch, filters.invoiceStartDate, filters.invoiceEndDate]);
  useEffect(() => {
    dispatch(Admin.actions.fetchContracts());
  }, [dispatch]);
  useEffect(() => {
    dispatch(Admin.actions.fetchRegistered());
  }, [dispatch]);

  const searchBillableIntentsAll = (billableIntent) => {
    if (
      true &&
      // && (billableIntent => billableIntent.psychologistName.toLowerCase().search(searchTerm.toLowerCase()) > -1 || searchTerm.length === 0)
      (billableIntent.clientName.toLowerCase().search(searchTerm.toLowerCase()) > -1 ||
        billableIntent.psychologistName.toLowerCase().search(searchTerm.toLowerCase()) > -1 ||
        billableIntent.bookingid.toString().search(searchTerm.toLowerCase()) > -1 ||
        billableIntent.contractName.toLowerCase().search(searchTerm.toLowerCase()) > -1 ||
        searchTerm.length === 0) &&
      (!filters.clientsPsychologist ||
        filters.clientsPsychologist === "All" ||
        (filters.clientsPsychologist && billableIntent.psychologistid === filters.clientsPsychologist.id)) &&
      (!filters.clientsContract ||
        filters.clientsContract === "All" ||
        (filters.clientsContract && billableIntent.contractid && billableIntent.contractid === filters.clientsContract.id)) &&
      (!filters.bookingPaymentType ||
        filters.bookingPaymentType === "All" ||
        (billableIntent.contractid !== 11 && billableIntent.bookingPaymentType === filters.bookingPaymentType) ||
        (filters.bookingPaymentType === "NTHQLDPHN" && billableIntent.contractid === 11)) &&
      (!filters.invoiceStatus || filters.invoiceStatus === "All" || billableIntent.billingstatus === filters.invoiceStatus) &&
      (!filters.bookingStatus ||
        filters.bookingStatus === "All" ||
        (filters.bookingStatus === "Active/NoShow" &&
          (billableIntent.bookingStatus === "Active" ||
            billableIntent.bookingStatus === "NoShow" ||
            billableIntent.bookingStatus === "LateCancel" ||
            billableIntent.bookingStatus === "LateCancelProvider" ||
            billableIntent.bookingStatus === "Attended")) ||
        (filters.bookingStatus !== "Active/NoShow" &&
          filters.bookingStatus === "Active" &&
          (billableIntent.billingstatus === "Active" || billableIntent.billingstatus === "Attended")) ||
        (filters.bookingStatus !== "Active/NoShow" && billableIntent.bookingStatus === filters.bookingStatus)) &&
      (!filters.bookingProviderType || filters.bookingProviderType === "All" || billableIntent.providerType === filters.bookingProviderType) &&
      (!filters.bookingSessionType || filters.bookingSessionType === "All" || billableIntent.sessionType === filters.bookingSessionType) &&
      (!filters.rhcPaymentStatus || filters.rhcPaymentStatus === "All" || billableIntent.rhcpaymentstatus === filters.rhcPaymentStatus) &&
      (!filters.hubdocStatus ||
        filters.hubdocStatus === "All" ||
        (filters.hubdocStatus === "Uploaded" && billableIntent.invoiceExists === true) ||
        (filters.hubdocStatus === "Missing" && billableIntent.invoiceExists === false)) &&
      (!filters.bookingValidationStatus ||
        filters.bookingValidationStatus === "All" ||
        (filters.bookingValidationStatus === "Issue" && billableIntent.validationStatus && billableIntent.validationStatus.length > 0))
    ) {
      return billableIntent;
    }
  };

  const filteredbillableIntentsAll = billableIntentsAll.filter((billableIntent) => searchBillableIntentsAll(billableIntent));
  const [showBooking, setShowBooking] = useState(false);
  const [clientName, setClientName] = useState();
  const [bookingID, setBookingID] = useState();
  const [bookingStatus, setBookingStatus] = useState();
  const [paymentType, setPaymentType] = useState();
  const [subPaymentType, setSubPaymentType] = useState();
  const [providerType, setProviderType] = useState();
  const [ndisPlanManagementProvider, setNDISPlanManagementProvider] = useState();
  const [ndisEmailForInvoices, setNDISEmailForInvoices] = useState();
  const [bookingNote, setBookingNote] = useState();
  const [approvalstatus, setApprovalStatus] = useState();
  const [rhcpaymentstatus, setRHCPaymentStatus] = useState();
  const [validationStatus, setValidationStatus] = useState();

  const loadBooking = (thisBooking) => {
    setClientName(thisBooking.clientName);
    setBookingID(thisBooking.bookingid);
    setBookingStatus(thisBooking.bookingStatus);
    setProviderType(thisBooking.providerType);
    setcurrentContract(contracts.find((contract) => contract.id === thisBooking.contractid));
    setPaymentType(thisBooking.bookingPaymentType);
    setSubPaymentType(thisBooking.bookingSubPaymentType);
    setNDISPlanManagementProvider(thisBooking.ndisPlanManagementProvider);
    setNDISEmailForInvoices(thisBooking.ndisEmailForInvoices);
    setBookingNote(thisBooking.bookingNote);
    setApprovalStatus(thisBooking.approvedstatus);
    setRHCPaymentStatus(thisBooking.rhcpaymentstatus);
    setValidationStatus(thisBooking.validationStatus);
    setShowBooking(true);
  };

  const downloadInvoice = (bookingID) => {
    dispatch(Admin.actions.fetchBookingInvoice({ bookingID: bookingID }));
  };

  useEffect(() => {
    if (bookingInvoice && bookingInvoice.base64Data) {
      const byteCharacters = atob(bookingInvoice.base64Data);
      const byteNumbers = new Array(byteCharacters.length);
      for (let i = 0; i < byteCharacters.length; i++) {
        byteNumbers[i] = byteCharacters.charCodeAt(i);
      }
      const blob = new Blob([new Uint8Array(byteNumbers)], {
        type: bookingInvoice.contentType || "application/octet-stream",
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = bookingInvoice.fileName || "download";
      document.body.appendChild(link);
      link.click();
      link.remove();
      window.URL.revokeObjectURL(url);
    }
  }, [bookingInvoice]);

  function UpdateBooking() {
    // Create payload to send to API
    var payload = {
      id: bookingID,
      paymenttype: paymentType,
      subpaymenttype: subPaymentType,
      contractid: currentContract && currentContract.id,
      status: bookingStatus,
      approvalstatus: approvalstatus,
      rhcpaymentstatus: rhcpaymentstatus,
      refresh: "ALL",
    };

    process.env.REACT_APP_DEBUG && console.log(payload);
    process.env.REACT_APP_DEBUG && console.log("Saving data");
    // Save update
    dispatch(Admin.actions.updateBookingBilling(payload));
    setShowBooking(false);
  }

  const handleSearch = (event) => {
    const searchTerm = event.target.value;
    setSearchTerm(searchTerm);
  };

  function handleBookingClose() {
    setShowBooking(false);
  }

  const getContractOption = (option, value) => {
    // console.log(option);
    // console.log(value);
    if (option.id === value.id) {
      return option;
    } else {
      return initContract();
    }
  };

  const columns = [
    {
      field: "id",
      headerName: "ID",
      width: 100,
      renderCell: (params) => (
        <>
          <strong>
            <div onClick={() => loadBooking(billableIntentsAll.find((booking) => booking.id === params.row.id))} className="cell-Link">
              {params.value}
            </div>
          </strong>
        </>
      ),
    },
    {
      field: "psychologistid",
      headerName: "Psychologist ID",
      width: 100,
      hide: true,
    },
    {
      field: "psychologistSurname",
      headerName: "psychologistSurname",
      width: 100,
      hide: true,
    },
    {
      field: "invoiceExists",
      headerName: "Inv.",
      width: 70,
      sortable: false,
      renderCell: (params) => {
        if (!params.value) return null;

        return (
          <IconButton
            size="small"
            onClick={(e) => {
              e.stopPropagation();
              downloadInvoice(params.row.id);
            }}
          >
            <CloudDownloadIcon fontSize="small" sx={{ color: "green" }} htmlColor="green" />
          </IconButton>
        );
      },
      valueFormatter: () => "", // prevents "false" showing anywhere
    },
    {
      field: "psychologistName",
      headerName: "Provider Name",
      width: 250,
      renderCell: (params) => {
        return (
          <strong>
            {params.row.validationStatus && params.row.validationStatus.length > 0 ? (
              <>
                <span style={{ color: "red" }}>{params.value}</span>
              </>
            ) : (
              <>{params.value}</>
            )}
          </strong>
        );
      },
    },
    { field: "clientName", headerName: "Client Name", width: 250 },
    { field: "bookingDate", headerName: "Booking Date", width: 150 },
    { field: "duration", headerName: "Duration", width: 150 },
    { field: "bookingStatus", headerName: "Booking Status", width: 150 },
    { field: "bookingPaymentType", headerName: "Payment Type", width: 150 },
    { field: "bookingSubPaymentType", headerName: "Sub", width: 100 },
    { field: "contractid", headerName: "Contract ID", width: 100, hide: true },
    { field: "contractName", headerName: "Contract", width: 150 },
    // { field: 'ndisEmailForInvoices', headerName: 'NDIS Email', width: 150 },
    {
      field: "rhcpaymentstatus",
      headerName: "Paid by RHC",
      width: 150,
      renderCell: (params) => {
        return (
          <>
            {params.row.contractid ? (
              <>{params.value === "Paid" ? <span style={{ color: "green" }}>{params.value}</span> : <span style={{ color: "red" }}>{params.value}</span>}</>
            ) : null}
          </>
        );
      },
    },
    { field: "sessionType", headerName: "Session Type", width: 150 },
    { field: "providerfee", headerName: "Fee", width: 100 },
    { field: "billingstatus", headerName: "Billing Status", width: 150 },
    { field: "uploadedHubDoc", headerName: "Hub Doc", width: 120 },
    {
      field: "validationStatus",
      headerName: "Validation",
      width: 150,
      hide: true,
    },
  ];

  return (
    <>
      <Grid container direction="row" justifyContent="space-between">
        <Grid item>
          <h4 style={{ marginBottom: 12 }}>Review All Bookings</h4>
        </Grid>
      </Grid>

      <Paper>
        <Grid container style={{ padding: 10 }}>
          <Grid item style={{ paddingLeft: 2, paddingRight: 10 }}>
            {/* <Grid item style={{ marginTop: 2, marginLeft: 10 }}> */}
            <InputGroup size="sm">
              <InputGroup.Prepend>
                <InputGroup.Text>
                  <SearchIcon fontSize="small" style={{ marginLeft: -4 }} />
                </InputGroup.Text>
              </InputGroup.Prepend>
              <Form.Control type="text" value={searchTerm} onChange={(event) => handleSearch(event)} autoComplete="OFF" style={{ height: 33 }} />
            </InputGroup>
          </Grid>
          <Grid item style={{ paddingRight: 10 }}>
            <Autocomplete
              id="searchPsychologist"
              variant="outlined"
              options={registered}
              getOptionLabel={(option) => ((filters.clientsPsychologist === "All" && !option.fullname) || !option.fullname ? "All" : option.fullname)}
              value={filters.clientsPsychologist === "All" ? null : filters.clientsPsychologist}
              onChange={(event, newValue) =>
                dispatch(
                  Admin.actions.setFilters({
                    filterName: "clientsPsychologist",
                    filterValue: newValue ? newValue : "All",
                  }),
                )
              }
              style={{
                minWidth: 200,
                fullWidth: true,
                display: "flex",
                wrap: "nowrap",
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Provider"
                  type="text"
                  variant="outlined"
                  margin="dense"
                  name="PsychologistSelector"
                  style={{
                    backgroundColor: "white",
                    margin: 0,
                    padding: 0,
                    maxWidth: 200,
                  }}
                  inputProps={{
                    ...params.inputProps,
                    autoComplete: "new-password",
                  }}
                />
              )}
            />
          </Grid>
          <Grid item style={{ paddingRight: 10 }}>
            <Autocomplete
              id="searchContract"
              variant="outlined"
              options={contracts}
              getOptionLabel={(option) => ((filters.clientsContract === "All" && !option.name) || !option.name ? "All" : option.name)}
              value={filters.clientsContract === "All" ? null : filters.clientsContract}
              onChange={(event, newValue) =>
                dispatch(
                  Admin.actions.setFilters({
                    filterName: "clientsContract",
                    filterValue: newValue ? newValue : "All",
                  }),
                )
              }
              style={{
                minWidth: 200,
                fullWidth: true,
                display: "flex",
                wrap: "nowrap",
              }}
              renderInput={(params) => (
                <TextField
                  {...params}
                  label="Contract/EAP"
                  type="text"
                  variant="outlined"
                  margin="dense"
                  name="ContractSelector"
                  style={{
                    backgroundColor: "white",
                    margin: 0,
                    padding: 0,
                    maxWidth: 200,
                  }}
                  inputProps={{
                    ...params.inputProps,
                    autoComplete: "new-password",
                  }}
                />
              )}
            />
          </Grid>
          <Grid item style={{ paddingRight: 10 }}>
            <FormControl variant="outlined" className={classes.formControl} size="small">
              <InputLabel id="Status-label" className={classes.label}>
                {" "}
                Status
              </InputLabel>
              <Select
                labelId="Status-label"
                id="StatusFilter"
                margin="dense"
                style={{
                  minWidth: 120,
                  backgroundColor: "#ffffff",
                  height: 33,
                }}
                value={filters.bookingStatus}
                onChange={(event) =>
                  dispatch(
                    Admin.actions.setFilters({
                      filterName: "bookingStatus",
                      filterValue: event.target.value,
                    }),
                  )
                }
              >
                <MenuItem value="All">All</MenuItem>
                <MenuItem value="Active/NoShow">Active/No Show</MenuItem>
                <MenuItem value="Active">Active</MenuItem>
                <MenuItem value="NoShow">No Show</MenuItem>
                <MenuItem value="LateCancel">Late Cancellation</MenuItem>
                <MenuItem value="LateCancelProvider">Late Cancellation by Provider</MenuItem>
                <MenuItem value="Cancelled">Cancelled</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item style={{ paddingRight: 10 }}>
            <FormControl variant="outlined" className={classes.formControl} size="small">
              <InputLabel id="SessionType-label" className={classes.label}>
                {" "}
                Session Type
              </InputLabel>
              <Select
                labelId="SessionType-label"
                id="SessionTypeFilter"
                margin="dense"
                style={{
                  minWidth: 120,
                  backgroundColor: "#ffffff",
                  height: 33,
                }}
                value={filters.bookingSessionType}
                onChange={(event) =>
                  dispatch(
                    Admin.actions.setFilters({
                      filterName: "bookingSessionType",
                      filterValue: event.target.value,
                    }),
                  )
                }
              >
                <MenuItem value="All">All</MenuItem>
                <MenuItem value="Normal">Normal</MenuItem>
                <MenuItem value="P0102">P0102 - Psychology Therapy Session</MenuItem>
                <MenuItem value="P0202">P0202 - Psychology Therapy Session</MenuItem>
                <MenuItem value="P0101">P0101 - Psychology Diagnostic Assessment & Report (One-off Appt)</MenuItem>
                <MenuItem value="P0201">P0201 - Psychology Diagnostic Assessment & Report (One-off Appt)</MenuItem>
                <MenuItem value="P0103">P0103 - Primary Psychology case conference</MenuItem>
                <MenuItem value="P0203">P0203 - Primary Psychology case conference</MenuItem>
                <MenuItem value="P0304">P0304 - Primary Psychiatry Assessment and Report</MenuItem>
                <MenuItem value="P0305">P0305 - Primary Psychiatry Follow-up Review</MenuItem>
                <MenuItem value="P0306">P0306 - Primary Psychiatry Case Conference</MenuItem>
                <MenuItem value="S0108">S0108 - Case Review Meeting (No Client) (SCC)</MenuItem>
                <MenuItem value="S0208">S0208 - Case Review Meeting (No Client) (SCC)</MenuItem>
                <MenuItem value="S0309">S0309 - Secondary Psychiatry Case Conference</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item style={{ paddingRight: 10 }}>
            <FormControl variant="outlined" className={classes.formControl} size="small">
              <InputLabel id="ProviderType-label" className={classes.label}>
                {" "}
                Provider Type
              </InputLabel>
              <Select
                labelId="ProviderType-label"
                id="ProviderTypeFilter"
                margin="dense"
                style={{
                  minWidth: 120,
                  backgroundColor: "#ffffff",
                  height: 33,
                }}
                value={filters.bookingProviderType}
                onChange={(event) =>
                  dispatch(
                    Admin.actions.setFilters({
                      filterName: "bookingProviderType",
                      filterValue: event.target.value,
                    }),
                  )
                }
              >
                <MenuItem value="All">All</MenuItem>
                <MenuItem value="Psychologist">Psychologist</MenuItem>
                {/* <MenuItem value="Financial">Financial Counsellor</MenuItem> */}
                <MenuItem value="Clinical">Clinical Psychologist</MenuItem>
                <MenuItem value="GP">GP</MenuItem>
                <MenuItem value="Provisional">Provisional Psychologist</MenuItem>
                <MenuItem value="Social">MH Social Worker</MenuItem>
                <MenuItem value="Nurse">Mental Health Nurse</MenuItem>
                <MenuItem value="Occupational">Occupational Therapist</MenuItem>
                {/* <MenuItem value="NDIS">NDIS</MenuItem> */}
                <MenuItem value="Psychiatrist">Psychiatrist</MenuItem>
                {/* <MenuItem value="Supervision">Supervision</MenuItem> */}
              </Select>
            </FormControl>
          </Grid>
          <Grid item style={{ paddingRight: 10 }}>
            <FormControl variant="outlined" className={classes.formControl} size="small">
              <InputLabel id="PaymentType-label" className={classes.label}>
                {" "}
                Payment Type
              </InputLabel>
              <Select
                labelId="PaymentType-label"
                id="PaymentTypeFilter"
                margin="dense"
                style={{
                  minWidth: 120,
                  backgroundColor: "#ffffff",
                  height: 33,
                }}
                value={filters.bookingPaymentType}
                onChange={(event) =>
                  dispatch(
                    Admin.actions.setFilters({
                      filterName: "bookingPaymentType",
                      filterValue: event.target.value,
                    }),
                  )
                }
              >
                <MenuItem value="All">All</MenuItem>
                <MenuItem value="Full Fee">Full Fee</MenuItem>
                <MenuItem value="Reduced Gap">Reduced Gap</MenuItem>
                <MenuItem value="Reduced GapX">'Reduced GapX</MenuItem>
                <MenuItem value="Bulk Billed">Bulk Billed</MenuItem>
                <MenuItem value="NDIS">NDIS</MenuItem>
                <MenuItem value="Contract">Contract</MenuItem>
                <MenuItem value="EAP">EAP</MenuItem>
                <MenuItem value="NTHQLDPHN">NTHQLDPHN</MenuItem>
                <MenuItem value="CentralisedService">Centralised Service</MenuItem>
                <MenuItem value="Provisional">Provisional</MenuItem>
                <MenuItem value="Supervision">Supervision</MenuItem>
                <MenuItem value="TAC">Transport Accident Commmission</MenuItem>
                <MenuItem value="WorkCover">Work Cover</MenuItem>
                <MenuItem value="DVA">Department of Veterans` Affairs</MenuItem>
                <MenuItem value="Island">Island (Cocos and Christmas Islands)</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item style={{ paddingRight: 10 }}>
            <FormControl variant="outlined" className={classes.formControl} size="small">
              <InputLabel id="invoiceStatus-label" className={classes.label}>
                {" "}
                Billing Status
              </InputLabel>
              <Select
                labelId="InvoiceStatus-label"
                id="InvoiceStatus"
                margin="dense"
                style={{
                  minWidth: 120,
                  backgroundColor: "#ffffff",
                  height: 33,
                }}
                value={filters.invoiceStatus}
                onChange={(event) =>
                  dispatch(
                    Admin.actions.setFilters({
                      filterName: "invoiceStatus",
                      filterValue: event.target.value,
                    }),
                  )
                }
              >
                <MenuItem value="All">All</MenuItem>
                <MenuItem value="Billed">Billed</MenuItem>
                <MenuItem value="Unbilled">UnBilled</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item style={{ paddingRight: 10 }}>
            <FormControl variant="outlined" className={classes.formControl} size="small">
              <InputLabel id="rhcPaymentStatus-label" className={classes.label}>
                {" "}
                Paid by RHC
              </InputLabel>
              <Select
                labelId="rhcPaymentStatus-label"
                id="rhcPaymentStatus"
                margin="dense"
                style={{
                  minWidth: 120,
                  backgroundColor: "#ffffff",
                  height: 33,
                }}
                value={filters.rhcPaymentStatus}
                onChange={(event) =>
                  dispatch(
                    Admin.actions.setFilters({
                      filterName: "rhcPaymentStatus",
                      filterValue: event.target.value,
                    }),
                  )
                }
              >
                <MenuItem value="All">All</MenuItem>
                <MenuItem value="UnPaid">UnPaid</MenuItem>
                <MenuItem value="Paid">Paid</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item style={{ paddingRight: 10 }}>
            <FormControl variant="outlined" className={classes.formControl} size="small">
              <InputLabel id="hubdocStatus-label" className={classes.label}>
                {" "}
                Hub Doc
              </InputLabel>
              <Select
                labelId="hubdocStatus-label"
                id="hubdocStatus"
                margin="dense"
                style={{
                  minWidth: 120,
                  backgroundColor: "#ffffff",
                  height: 33,
                }}
                value={filters.hubdocStatus}
                onChange={(event) =>
                  dispatch(
                    Admin.actions.setFilters({
                      filterName: "hubdocStatus",
                      filterValue: event.target.value,
                    }),
                  )
                }
              >
                <MenuItem value="All">All</MenuItem>
                <MenuItem value="Uploaded">Yes</MenuItem>
                <MenuItem value="Missing">No</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item style={{ paddingRight: 10 }}>
            <FormControl variant="outlined" className={classes.formControl} size="small">
              <InputLabel id="ValidationStatus-label" className={classes.label}>
                {" "}
                Validation
              </InputLabel>
              <Select
                labelId="ValidationStatus-label"
                id="ValidationStatusFilter"
                margin="dense"
                style={{
                  minWidth: 120,
                  backgroundColor: "#ffffff",
                  height: 33,
                }}
                value={filters.bookingValidationStatus}
                onChange={(event) =>
                  dispatch(
                    Admin.actions.setFilters({
                      filterName: "bookingValidationStatus",
                      filterValue: event.target.value,
                    }),
                  )
                }
              >
                <MenuItem value="All">All</MenuItem>
                <MenuItem value="Issue">Issue</MenuItem>
              </Select>
            </FormControl>
          </Grid>
          <Grid item style={{ marginLeft: 10, display: "flex", alignItems: "center" }}>
            <span style={{ marginRight: 5, fontSize: 13 }}>Start:</span>
            <Form.Control
              type="date"
              id="invoiceStartDate"
              name="invoiceStartDate"
              value={filters.invoiceStartDate || ""}
              onChange={(e) =>
                dispatch(
                  Admin.actions.setFilters({
                    filterName: "invoiceStartDate",
                    filterValue: e.target.value,
                  }),
                )
              }
              style={{ maxWidth: 140, height: 35 }}
            />
          </Grid>
          <Grid item style={{ marginLeft: 10, display: "flex", alignItems: "center" }}>
            <span style={{ marginRight: 5, fontSize: 13 }}>End:</span>
            <Form.Control
              type="date"
              id="invoiceEndDate"
              name="invoiceEndDate"
              value={filters.invoiceEndDate || ""}
              onChange={(e) =>
                dispatch(
                  Admin.actions.setFilters({
                    filterName: "invoiceEndDate",
                    filterValue: e.target.value,
                  }),
                )
              }
              style={{ maxWidth: 140, height: 35 }}
            />
          </Grid>
        </Grid>
      </Paper>

      {billableIntentsAll ? (
        <Paper style={{ height: 700 }}>
          <DataGrid
            rows={filteredbillableIntentsAll}
            columns={columns}
            pageSize={10}
            checkboxSelection={false}
            rowHeight={40}
            sortModel={[{ field: "psychologistSurname", sort: "asc" }]}
          />
        </Paper>
      ) : (
        "None"
      )}

      <Modal show={showBooking} onHide={handleBookingClose} dialogClassName="editprofile-modal">
        <Modal.Header closeButton className="editprofile-modal">
          <Modal.Title>Update Booking Status and Funding - {clientName}</Modal.Title>
        </Modal.Header>
        <Modal.Body className="editprofile-modal">
          <Row>
            <Col md="3">
              <Form.Group style={{ width: "100%" }}>
                <Form.Label style={{ color: "green", fontWeight: 500 }}>Booking Status</Form.Label>
                <Form.Control as="select" defaultValue={bookingStatus} onChange={(event) => setBookingStatus(event.target.value)}>
                  <option value="Active">Billable</option>
                  <option value="Cancelled">Cancelled</option>
                  <option value="NoShow">No Show</option>
                  <option value="LateCancel">Late Cancellation</option>
                  <option value="LateCancelProvider">Late Cancellation by Provider</option>
                  <option value="Deleted" disabled>
                    Deleted
                  </option>
                </Form.Control>
              </Form.Group>
            </Col>
            <Col md="3">
              <Form.Group style={{ width: "100%" }}>
                <Form.Label style={{ color: "green", fontWeight: 500 }}>Funding Type</Form.Label>
                <Form.Control as="select" defaultValue={paymentType} onChange={(event) => setPaymentType(event.target.value)}>
                  <option value="Bulk Billed">Bulk Billed</option>
                  <option value="Reduced Gap">Reduced Gap (+$20)</option>
                  <option value="Full Fee">Full Fee</option>
                  <option value="NDIS">NDIS</option>
                  <option value="Contract">Contract</option>
                </Form.Control>
              </Form.Group>
            </Col>
            {paymentType === "Reduced Gap" || paymentType === "Full Fee" ? (
              <>
                <Col md="3">
                  <Form.Group style={{ width: "100%" }}>
                    <Form.Label style={{ color: "green", fontWeight: 500 }}>Sub Payment Type</Form.Label>
                    <Form.Control as="select" defaultValue={subPaymentType} onChange={(event) => setSubPaymentType(event.target.value)}>
                      <option value="">N/A</option>
                      {providerType === "Clinical" ? (
                        <>
                          {paymentType === "Reduced Gap" ? (
                            <>
                              <option value="Over30C">Gap Over $30</option>
                              <option value="Under50C">Gap Under $50</option>
                            </>
                          ) : null}
                          <option value="Over50C">Gap Over $50</option>
                        </>
                      ) : (
                        <>
                          {paymentType === "Reduced Gap" ? (
                            <>
                              <option value="Over30">Gap Over $30</option>
                              <option value="Under50">Gap Under $50</option>
                            </>
                          ) : null}
                          <option value="Over50">Gap Over $50</option>
                        </>
                      )}
                    </Form.Control>
                  </Form.Group>
                </Col>
              </>
            ) : null}
            {paymentType === "Contract" || paymentType === "EAP" ? (
              <>
                <Col md="4">
                  <Form.Group style={{ width: "100%" }}>
                    <Form.Label style={{ color: "green", fontWeight: 500 }}>Contract</Form.Label>
                    <Autocomplete
                      id="contractID"
                      variant="outlined"
                      options={contracts}
                      getOptionLabel={(option) => option.name}
                      getOptionSelected={(option, value) => getContractOption(option, value)}
                      value={currentContract}
                      onChange={(event, newValue) => loadContract(newValue)}
                      style={{
                        minWidth: 200,
                        fullWidth: true,
                        display: "flex",
                        wrap: "nowrap",
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          type="text"
                          variant="outlined"
                          margin="dense"
                          name="currentContactID"
                          style={{
                            backgroundColor: "white",
                            margin: 0,
                            padding: 0,
                            maxWidth: 400,
                          }}
                          inputProps={{
                            ...params.inputProps,
                            autoComplete: "new-password",
                          }}
                        />
                      )}
                    />
                  </Form.Group>
                </Col>
                <Col md="3">
                  <Form.Group style={{ width: "100%" }}>
                    <Form.Label style={{ color: "green", fontWeight: 500 }}>Approval Status</Form.Label>
                    <Form.Control as="select" defaultValue={approvalstatus} disabled>
                      <option value="Approved">Approved</option>
                      <option value="Unapproved">Unapproved</option>
                    </Form.Control>
                  </Form.Group>
                </Col>
                <Col md="3">
                  <Form.Group style={{ width: "100%" }}>
                    <Form.Label style={{ color: "green", fontWeight: 500 }}>RHC Payment Status</Form.Label>
                    <Form.Control as="select" defaultValue={rhcpaymentstatus} onChange={(event) => setRHCPaymentStatus(event.target.value)}>
                      <option value="UnPaid">UnPaid</option>
                      <option value="Paid">Paid</option>
                    </Form.Control>
                  </Form.Group>
                </Col>
              </>
            ) : null}
          </Row>
          {paymentType === "NDIS" ? (
            <Row>
              <Col md="6">
                <Form.Group>
                  <Form.Label>NDIS Plan Management Provider</Form.Label>
                  <Form.Control type="text" name="ndisPlanManagementProvider" defaultValue={ndisPlanManagementProvider} readOnly />
                </Form.Group>
              </Col>
              <Col md="6">
                <Form.Group>
                  <Form.Label>NDIS Email for Invoices</Form.Label>
                  <Form.Control type="text" name="ndisEmailForInvoices" defaultValue={ndisEmailForInvoices} readOnly />
                </Form.Group>
              </Col>
            </Row>
          ) : null}
          {paymentType === "NDIS" || paymentType === "Contract" || paymentType === "EAP" ? (
            <Row>
              <Col md="12">
                <Form.Group>
                  <Form.Label>Booking Note</Form.Label>
                  <Form.Control as="textarea" rows={8} type="text" name="bookingNote" defaultValue={bookingNote} />
                </Form.Group>
              </Col>
            </Row>
          ) : null}
          {validationStatus && validationStatus.length > 0 ? (
            <Row>
              <Col md="12">
                <Form.Group>
                  <Form.Label>Warning</Form.Label>
                  <Form.Control type="text" name="validationStatus" defaultValue={validationStatus} readOnly />
                </Form.Group>
              </Col>
            </Row>
          ) : null}
        </Modal.Body>
        <Modal.Footer className="editprofile-modal">
          <Button variant="secondary" onClick={handleBookingClose}>
            Cancel
          </Button>
          <Button variant="primary" onClick={UpdateBooking}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>

      <ToastContainer
        position="bottom-right"
        transition={Flip}
        autoClose={5000}
        hideProgressBar={true}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </>
  );
}
